import React, { useState, useEffect } from "react";
import Upload from "./Upload";
import ManageUpload from "./ManageUpload";
import WrapperContainer from "./utilities/WrapperContainer";
import axios from "../api/axios";

export default function UploadFile() {
  const [activeType, setActiveType] = useState("upload");
  const [errorMessage, setErrorMessage] = useState([]);
  const [files, setFiles] = useState([]);
  const [fileSize, setFileSize] = useState();
  const handleTypeClick = (type) => {
    setActiveType(type);
  };

  const fetchData = async () => {
    axios
      .get("/api/get-files")
      .then((res) => {
        setFiles(res.data.files);
        setFileSize((res.data.totalSize / 1048576).toFixed(2));
      })
      .catch((err) => {
        setErrorMessage("Failed to fetch files");
      });
  };

  return (
    <>
      <WrapperContainer
        title="Upload Files"
        loggedin={true}
        buttons={
          <>
            <div className="buttons" data-toggle="buttons-radio">
              <button
                className={`menu-options px-4 ${
                  activeType === "upload" ? "btn-active" : "btn"
                }`}
                onClick={() => handleTypeClick("upload")}
              >
                <span> Upload Input Files</span>
              </button>
              <button
                className={`menu-options px-4 ${
                  activeType === "manage" ? "btn-active" : "btn"
                }`}
                onClick={() => handleTypeClick("manage")}
              >
                <span> Manage Uploaded Files</span>
              </button>
            </div>
            <div className="dropdown dropdown-buttons">
              <button
                className="btn dropdown-toggle"
                type="button"
                id="optionsMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {activeType === "upload"
                  ? "Upload Input Files"
                  : "Manage Uploaded Files"}
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="optionsMenu"
              >
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handleTypeClick("upload")}
                  >
                    Upload Input Files
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handleTypeClick("manage")}
                  >
                    Manage Uploaded Files
                  </a>
                </li>
              </ul>
            </div>
          </>
        }
        content={
          <>
            {activeType === "upload" && (
              <Upload
                existingFiles={files}
                size={fileSize}
                refreshData={fetchData}
                err={errorMessage}
              />
            )}
            {activeType === "manage" && (
              <ManageUpload
                data={files}
                size={fileSize}
                refreshData={fetchData}
              />
            )}
          </>
        }
      />
    </>
  );
}
